import { FC } from 'react'

import { Tooltip } from 'ui/components/Tooltip'

import { PermissionsProps } from './PermissionsProps'
import { Details } from './components/Details'

export const Permissions: FC<PermissionsProps> = (props) => {
  const { id, value } = props
  const enabledPermissions = value.filter((permission) => permission.enabled)

  const topLevelLabel =
    enabledPermissions
      .slice(0, 3)
      .map((i) => i.label)
      .join(', ') + (enabledPermissions.length > 3 ? '...' : '')

  return enabledPermissions.length > 0 ? (
    <Tooltip
      id={`client-user-permissions-tooltip-${id}`}
      type="dark"
      place="right"
      content={<Details permissions={value.filter((permission) => permission.enabled)} />}
      event="hover"
    >
      <span>{topLevelLabel}</span>
    </Tooltip>
  ) : (
    <span>---</span>
  )
}
